import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initTeamSlider() {
    const sliderElement = document.querySelector('.js-team-slider');
    
    if (!sliderElement) return;

    let swiperInstance = null;

    function initSwiper() {
        if (window.innerWidth < 768 && !swiperInstance) {
            swiperInstance = new Swiper(sliderElement, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.2,
                spaceBetween: 13,
                slidesOffsetAfter: 24,
                loop: false,
                pagination: {
                    el: '.swiper-teamblock-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.c_swiper-teamblock-next',
                    prevEl: '.c_swiper-teamblock-prev',
                },
            });
        } else if (window.innerWidth >= 768 && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
}
